
import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useAuth } from '../../hooks/useAuth'

const LoginPage = () => {
  const location = useLocation()
  const currentLocationState = location.state || {
    from: { pathname: '/dashboard' },
  }
  const { loginWithRedirect, isAuthenticated } = useAuth()

  useEffect(() => {
    if (!isAuthenticated) {
      const returnTo =
        location.state?.from?.pathname + (location.state?.from?.search || '') || '/dashboard'
      loginWithRedirect({ appState: { returnTo } })
    }
  }, [isAuthenticated, loginWithRedirect, location.state])

  if (isAuthenticated) {
    return <Navigate to={currentLocationState?.from as string} />
  }

  return <></>
}

export default LoginPage
